import type { FC, ReactNode } from 'react';
import { Checkbox, CheckboxProps } from '@chakra-ui/react';
import { DataProps } from '../../utils';

export type QCheckboxProps = Pick<
  CheckboxProps,
  | 'size'
  | 'isDisabled'
  | 'isChecked'
  | 'isInvalid'
  | 'isIndeterminate'
  | 'value'
  | 'onClick'
  | 'onChange'
  | 'isReadOnly'
> &
  DataProps & {
    children?: ReactNode;
  };

export const QCheckbox: FC<QCheckboxProps> = (props) => {
  const { size = 'sm' } = props;

  return <Checkbox {...props} size={size} />;
};
